import React from "react";
import "./tradeCard.scss";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SecurityIcon from "@mui/icons-material/Security";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import moment from "moment";
import { useSelector } from "react-redux";

const TradeDetailsCard = ({ trade, allTrades, profit }) => {
  const { chartData, loading } = useSelector(
    (state) => state.candlestickChart
  );

  const splitTrades = (trades) => {
    if (!Array.isArray(trades) || trades.length === 0) return { earliest: null, latest: null };

    return trades.reduce(
      (result, trade) => {
        const tradeDate = new Date(trade.date || trade.tradeDateTime);

        if (!result.earliest || tradeDate < new Date(result.earliest.date || result.earliest.tradeDateTime)) {
          result.earliest = trade;
        }

        if (!result.latest || tradeDate > new Date(result.latest.date || result.latest.tradeDateTime)) {
          result.latest = trade;
        }

        return result;
      },
      { earliest: null, latest: null }
    );
  };

  // inside your component
  const { earliest, latest } = splitTrades(allTrades?.info || []);
  const entry = earliest;
  const exit = latest;
  const getTradeDateTime = (trade) => {
    const tradeDate = trade?.date || trade?.tradeDateTime;
    return tradeDate
  }

  const normalizedTrade = {
    symbol: trade?.symbol || trade?.instrument || "-",
    trade_side: trade?.trade_side || trade?.action || trade?.side || "-",
    date: getTradeDateTime(trade),
    duration: trade?.duration || "-",
    volume: trade?.volume || trade?.lots || "-",
    profit: profit ?? 0,
    commission: trade?.commission ?? 0,
    entryPrice: entry?.price || "-",
    exitPrice: exit?.price || "-",
    stopLoss: trade?.stop_loss ?? trade?.stopLoss ?? "-",
    takeProfit: trade?.take_profit ?? trade?.takeProfit ?? "-",
    dealId: trade?.deal_id ?? trade?.deal ?? "-",
    positionId: trade?.position ?? "-",
  };
  console.log(chartData, 'normalizedTrade');

  const formatCurrency = (value) => {
    if (isNaN(value)) {
      return "-";
    }
    const abs = Math.abs(Number(value));
    const formatted = abs.toLocaleString("en-US", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
    return (value < 0 ? "- $" : "$") + formatted;
  };

  const getDuration = (start, end) => {
    if (!start || !end) return "--";
    const diff = Math.abs(new Date(end) - new Date(start)) / 1000;

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = Math.floor(diff % 60);

    const pad = (num) => String(num).padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const duration = getDuration(entry?.date || entry?.tradeDateTime, exit?.date || exit?.tradeDateTime);



  return (
    <div className="new-trade-card-info">
      <div className="top-part">
        <div>
          <p className="label">Type</p>
          {normalizedTrade?.trade_side === 'Buy' ? (
            <span className="value profit">
              <NorthWestIcon sx={{ color: "#4caf50", fontSize: 18 }} /> Buy
            </span>
          ) : (
            <span className="value loss">
              <SouthEastIcon sx={{ color: "#f44336", fontSize: 18 }} /> Sell
            </span>
          )}
        </div>
        <div>
          <p className="label">Open</p>
          <span className="value">
            {moment(normalizedTrade?.date).format("DD MMM YYYY , HH:mm:ss")}
          </span>
        </div>
        <div>
          <p className="label">Volume</p>
          <span className="value">{normalizedTrade?.volume}</span>
        </div>
        <div>
          <p className="label">Symbol</p>
          <span className="value">{normalizedTrade?.symbol}</span>
        </div>
        <div>
          <p className="label">PnL</p>
          <div className="grey-box">
            <span className={`value ${profit >= 0 ? "profit" : "loss"}`}>
              {" "}
              {formatCurrency(profit)}
            </span>
          </div>
        </div>
        <div>
          <p className="label">Pips</p>
          <div className="grey-box">

            <span className="value">-</span>
          </div>
        </div>
        <div>
          <p className="label">Duration</p>
          <span className="value">{duration}</span>
        </div>
      </div>
      <div className="bottom-part">
        <div className="section">
          <h4 className="section-title"><AttachMoneyIcon /> Price</h4>
          <p><span>Type:</span> {normalizedTrade?.trade_side}</p>
          <p><span>Open:</span> {normalizedTrade?.entryPrice}</p>
          <p><span>Close:</span> {normalizedTrade?.exitPrice}</p>
        </div>

        <div className="section">
          <h4 className="section-title"><SecurityIcon /> Trade Protection</h4>
          <p><span>SL:</span>{formatCurrency(normalizedTrade?.stopLoss)}</p>
          <p><span>SL Pips:</span> -</p>
          <p><span>TP:</span> {formatCurrency(normalizedTrade?.takeProfit)} </p>
          <p><span>TP Pips:</span> -</p>
        </div>

        <div className="section">
          <h4 className="section-title"> <CheckCircleOutlineOutlinedIcon /> Results</h4>
          <p className={`${profit >= 0 ? "profit" : "loss"}`}><span>Gross profit:</span>{formatCurrency(profit)}</p>
          <p><span>Swap:</span> --</p>
          <p><span>Comm.:</span> {formatCurrency(normalizedTrade?.commission)}</p>
          <p className={`${profit >= 0 ? "profit" : "loss"}`}><span>Net profit:</span>{formatCurrency(profit)}</p>
        </div>

        <div className="section">
          <h4 className="section-title"> <WatchLaterOutlinedIcon /> Time</h4>
          <p><span>Open  </span>{moment(entry?.date || entry?.tradeDateTime).format("DD MMM YYYY , HH:mm:ss")}</p>
          <p><span>Closed:</span> {moment(exit?.date || exit?.tradeDateTime).format("DD MMM YYYY , HH:mm:ss")}</p>

        </div>

        <div className="section">
          <h4 className="section-title">
            {" "}
            <ShowChartIcon /> Trade Stats <InfoOutlinedIcon />{" "}
          </h4>
          <p className="label">
            <span className="value">MAE Pip:</span> {chartData?.mae_pips?.toFixed(3) || '-'}
          </p>
          <p>
            <span>MAE:</span> {chartData?.mae?.toFixed(3) || '-'}
          </p>
          <p>
            <span>MAE Time:</span> {chartData?.mae_time ? moment(chartData?.mae_time)?.format("DD MMM YYYY , HH:mm:ss") : '-'}
          </p>
          <p>
            <span>MFE Pip:</span> {chartData?.mfe_pips?.toFixed(3) || '-'}
          </p>
          <p>
            <span>MFE:</span> {chartData?.mfe?.toFixed(3) || '-'}
          </p>
          <p>
            <span>MFE Time:</span> {chartData?.mfe_time ? moment(chartData?.mfe_time)?.format("DD MMM YYYY , HH:mm:ss") : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TradeDetailsCard;
